import { Component, Input, OnInit } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import moment from 'moment';

import { BayclubsAlertService } from '@bayclubs/alert';
import { ErrorTranslationService } from '@bayclubs/utils';

import { TextMaskService } from '@bayclubs/ui-text-mask';
import { camps } from '../../../../../models/models.generated';
import { CampCareApiService } from '../../../../../services/api/camp-care-api.service';
import { CampCareFormMode } from '../camp-care.mode';

@Component({
    selector: 'app-camp-care-days-generator',
    templateUrl: './camp-care-days-generator.component.html',
    styleUrls: ['./camp-care-days-generator.component.scss'],
    standalone: false
})
export class CampCareDaysGeneratorComponent implements OnInit {
    @Input()
    public campForm: UntypedFormGroup;

    public form: UntypedFormGroup;
    public isGeneratorVisible: boolean = false;
    public isBusy: boolean = false;

    public clubDropdownItems = [];

    constructor(
        public mask: TextMaskService,
        private campCareApi: CampCareApiService,
        private alert: BayclubsAlertService,
        private formBuilder: UntypedFormBuilder,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {
        this.isBusy = true;

        this.initForms();
    }

    private initForms() {
        this.form = this.formBuilder.group({
            ageInMonthsFrom: [12, [Validators.required]],
            ageInMonthsTo: [216, [Validators.required]],
            campId: [this.campForm.value.basicInfo.id, [Validators.required]],
            dateFrom: [null, [Validators.required]],
            dateTo: [null, [Validators.required]],
            clubCode: [[], [Validators.required]],
            slots: [[], [Validators.required]],
            capacity: [null, []],
            mode: [CampCareFormMode.Generate, []],
            ageInMonthsFromEffective: [12, [Validators.required]],
            ageInMonthsToEffective: [228, [Validators.required]],
        });

        this.form.get('dateFrom').valueChanges.subscribe((value: Date) => {
            if (
                value > this.form.value.dateTo &&
                this.form.value.dateTo &&
                this.form.value.dateFrom
            ) {
                this.form.controls.dateTo.setValue(value);
            }

            if (!this.form.value.dateTo) {
                this.form.controls.dateTo.setValue(
                    moment(value).add(5, 'days').format('YYYY-MM-DD')
                );
            }
        });
    }

    public generate(): void {
        var request = <camps.CampCareDaysGenerationRequest>{
            campId: this.form.value.campId,
            ageInMonthsFrom: this.form.value.ageInMonthsFrom,
            ageInMonthsTo: this.form.value.ageInMonthsTo,
            clubCode: this.form.value.clubCode,
            dateFrom: this.form.value.dateFrom,
            dateTo: this.form.value.dateTo,
            capacity: this.form.value.capacity,
            slots: this.form.value.slots,
        };

        this.campCareApi.generateDays(request).subscribe((result) => {
            if (result.isSuccess) {
                this.result = result.value;
            } else {
                this.errorTranslate.translateValidationNotifications(
                    result.validationNotification
                );
                this.alert.showError(
                    result.validationNotification.errors[0].message
                );
            }
        });
    }

    public result: camps.CampCareDaysGenerationResult;

    public onClose() {
        this.closeModal();
    }

    close: Function;
    closeModal(): void {
        this.close();
    }
}
